import { AxiosError } from 'axios';
import instance from '../config/axios';

export const getAllProducts = async (token: string) => {
  try {
    const response = await instance.get(`/api/v1/search/products`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (err) {
    console.error(err);
    return (err as AxiosError).response?.status as number;
  }
};
